import { Grid, Typography } from "@mui/material";
import { limitNumber } from "../../utils/limitNumber";

const styles = {
  commentWrapper: {
    width: "2.5rem",
    height: "3.875rem",
    bgcolor: "lightGrey",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "6px",
  },
  commentNumber: { fontSize: "0.875rem", fontWeight: "500" },
  commentText: {
    fontSize: "0.75rem",
    fontWeight: "normal",
    mt: "0.125rem",
    color: "brownishGrey",
  },
};

export const CafeCardComment = ({ comment }: { comment: number }) => (
  <Grid container direction="column" item sx={styles.commentWrapper}>
    <Typography sx={styles.commentNumber}>
      {limitNumber(comment, 999)}
    </Typography>
    <Typography sx={styles.commentText}>댓글</Typography>
  </Grid>
);
